import React, {useState, useRef} from "react";
 const stylecalctext2 = {
        fontSize: "24px",
        fontWeight: "bold"
    }
    const stylecalctext3 = {
        paddingTop: "20px",
        fontSize: "18px",
        fontWeight: "normal"
    }
    const stylecalcdetails = {
        paddingTop: "50px",
        color: "#FFAB2D",
        fontSize: "18px"
    }
export default function Calc() {
    const [debt, setDebt] = useState(500000)
    const [quest, setQuest] = useState(1)
    const rate = (e) => {
        setDebt(e.target.value)
    }
    const rate2 = (e) => {
        setQuest(e.target.value)
    }
    const back = () => {
        setQuest(parseInt(quest)  - 1)
        if (parseInt(quest) < 2)
            setQuest(1)
        
    }
    const forward = () => {
        setQuest(parseInt(quest) + 1)
        if (parseInt(quest) > 4)
            setQuest(5)
    }
    return (
        <>
            <div id="bankcalc_"/>
            <div id="bankcalc">
            <div className="container-fluid  calc">
                <div className="row">
                    <div className="col-sm">
                    <div id="calctitle">Рассчитайте стоимость банкротства</div>
                    <div id="calctext">Калькулятор сформирует полный пакет документов конкретно для Вашего случая</div>
                    <div id="debt">Укажите сумму вашего долга</div>
                    <div id="debtsummall">Сумма долга: <span id="debtsumm">{debt} ₽</span></div>
                    <input type="range" id="polzunbig" defaultValue={debt} min="0" max="1500000" step="10000" onChange={rate}/>
                     <div className="container-fluid">
                        <div className="row">
                            <div className="col-sm margpadlr" id="quest">Вопрос {quest} из 5<br />
                                        <input type="range" id="polzunsmall" value={quest} defaultValue={quest} min="0" max="5" step="1" onChange={rate2}/>
                            </div>
                            <div className="col-sm"><button id="back" onClick={back}>Назад</button></div>
                            <div className="col-sm"><button id="forward" onClick={forward}>Далее &#8594;</button></div>
                        </div>
                     </div>
                    </div>
                    <div className="col-sm" id="calc2">
                        <div style={stylecalctext2}>Посмотрите наши завершенные дела</div>
                        <div style={stylecalctext3}>Мы строго соблюдаем конфиденциальность наших клиентов. В разделе только те судебные решения, на опубликование которых нам дано разрешение.</div>
                        <div style={stylecalcdetails} ><a href="#" style={stylecalcdetails}>Подробнее</a></div>
                    </div>
                </div>
            </div>
        </div>
            </>
    )
}